export default __webpack_public_path__ + "static/media/timeDropdown3Day.48579270.png";